
const driveOptions = [
    { id: "Rear Wheel Drive", label: "Rear Wheel Drive",letter: "RWD" },
    { id: "Front Wheel Drive", label: "Front Wheel Drive",letter: "FWD" },
    { id: "All Wheel Drive", label: "All Wheel Drive",letter: "AWD" },
    { id: "Unknown", label: "Unknown",letter: "U" },
  ];
  
  // API key
  const driveAPIKey = "drive"; 
  
  // Label
  const driveLabel = "Drive Type"; 
  
  export { driveOptions, driveLabel, driveAPIKey };
  